/**
 * Format a numeric amount as a localized currency string.
 *
 * @param {number} amount  – the value to format
 * @param {string} [currency="SEK"] – ISO 4217 currency code
 * @returns {string} formatted currency string (e.g. "12 500,00 kr")
 */
export function formatCurrency(amount, currency = "SEK") {
  return new Intl.NumberFormat("sv-SE", {
    style: "currency",
    currency,
  }).format(amount);
}
